import Vue from 'vue'
import Vuex from 'vuex'

// Modules
import ecommerceStoreModule from '@/views/apps/e-commerce/eCommerceStoreModule'
import propertiesStoreModule from '@/views/properties/propertiesStoreModule'
import app from './app'
import appConfig from './app-config'
import verticalMenu from './vertical-menu'
import propertyConfig from './property-config'
import chatbot from './chatbot'
import notifications from './notifications'

Vue.use(Vuex)

export default new Vuex.Store({
  modules: {
    app,
    appConfig,
    verticalMenu,
    propertyConfig,
    chatbot,
    notifications,
    'app-ecommerce': ecommerceStoreModule,
    'app-p': propertiesStoreModule,
  },
  strict: process.env.DEV,
})
